const initCarousels = ()=> {
    // get all carousels from the page
    let $carousels = $(".js-generic-carousel");

    if ($carousels.length) {
        /**
         * Initializes the carousel with slick.js
         * @param {Object} $carousels - jQuery object of the carousel
         * @returns {void}
         */
        $carousels.each(function () {
            const $this = $(this);

            if (!$this.hasClass(".slick-initialized")) {
                $this.slick({
                    mobileFirst: true,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 1.1,
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    }]
                });
            }
        });
    }
};

export default ()=> {
    initCarousels();
};
